import { useNavigate } from "react-router-dom";
import { pricingListArray, registeringForm } from "../../../utils/string";
import Banner from "../../search/banner";
import PricingCard from "./PricingCard";

const PricingList = () => {
  let navigate = useNavigate();
  return (
    <>
      {" "}
      <div>
        <div className="bg-[#F2F2F2]">
          <Banner
            path={
              <>
                <span onClick={() => navigate("/")} className="cursor-pointer">
                  HOME
                </span>
                {" > "} SIGN UP / COMPLETE THIS INFORMATION
              </>
            }
          />
        </div>
        <div className="bg-[#fff] pb-[100px]">
          <div className="custom-container">
            <div className="py-[29px]">
              <div className="text-[#161412] lg:text-[48px] md:text-[38px] sm:text-[28px] text-[18px] font-[Roboto] font-black	text-center mb-[30px]">
                {registeringForm.SELECT_PLAN}
              </div>

              <div className="grid 2xl:grid-cols-4 lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-4">
                {pricingListArray.map((item) => {
                  return <PricingCard item={item} />;
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default PricingList;
